@use 'themes/westfield' as *;
// Icons should never change size

.Icon {
  flex-shrink: 0;
  flex-grow: 0;
}

a > svg,
button > svg {
  pointer-events: none;
}
